import React from 'react';

import { CurrencyInputField as CurrencyInputFieldComponent } from '@occc/ui-design-system';
import { TextField, TextFieldProps, TextFieldWrapperProps } from './TextField';
import { hasError, parseCurrencyNumber } from './utils';

const renderTextField = (props: TextFieldWrapperProps) => {
  const { name, type, fieldRenderProps, ...restProps } = props;

  const {
    input: { value, onChange },
    meta,
  } = fieldRenderProps;
  const { error, submitError } = meta;

  const isError = hasError(meta);
  const errorText = error || submitError;
  const helperText = isError ? errorText : props.helperText;

  return (
    <CurrencyInputFieldComponent
      name={name}
      error={isError}
      helperText={helperText}
      value={value}
      onChange={onChange}
      type={type}
      {...restProps}
    />
  );
};

type ValueType = 'dollars' | 'cents';
type CurrencyInputFieldProps = TextFieldProps & {
  valueType?: ValueType;
};

const valueToNumber = (value: any): number => {
  if (typeof value === 'string') {
    return parseFloat(value);
  }
  if (typeof value === 'number') {
    return value;
  }
  throw new Error('valueToNumber: Invalid value');
};

const mappings: Record<ValueType, { parse: (value: any) => any; format?: (value: any) => any }> = {
  dollars: {
    parse: parseCurrencyNumber,
  },
  cents: {
    format: (_value: any) => {
      // Handle empty string, undefined, null
      if (typeof _value !== 'number' && !_value) return '';
      const value = valueToNumber(_value);
      return parseFloat((value / 100).toFixed(2));
    },
    parse: (_value: any) => {
      // Handle empty string, undefined, null
      if (typeof _value !== 'number' && !_value) return undefined;
      const value = valueToNumber(_value);
      return Math.trunc(value * 100);
    },
  },
};

export const CurrencyInputField: React.FC<CurrencyInputFieldProps> = (props) => {
  const { valueType = 'dollars', ...rest } = props;
  return (
    <TextField
      type='number'
      {...rest}
      renderTextField={renderTextField}
      fieldProps={{
        ...mappings[valueType],
        ...props.fieldProps,
      }}
    />
  );
};
